/**
 * The latest number of subscriptions the user can see on a free tier (this may be overridden by the benefits logic)
 */
export const SUBSCRIPTIONS_ON_FREE_TIER = 2;
